import RadioInput from 'components/RadioGroup/RadioInput'
import { Box } from '@chakra-ui/react'
import { InfoOutlineIcon } from '@chakra-ui/icons'
import { ReactComponent as MedicalIcon } from '../../assets/images/clinic-stroke-rounded.svg'
import { ReactComponent as NutritionIcon } from '../../assets/images/dish-02-stroke-rounded.svg'

interface AppointmentOptionProps {
  appointmentTypeId: string | undefined
  appointmentText: string
  handleSelect: () => void | undefined
  isSelected: boolean
  isDisabled: boolean
}

const AppointmentOption: React.FC<AppointmentOptionProps> = ({
  appointmentTypeId,
  appointmentText,
  handleSelect,
  isSelected,
  isDisabled,
}: AppointmentOptionProps) => {
  const getAppointmentContainerClasses = (
    isSelected: boolean,
    isDisabled: boolean
  ) => {
    const baseClasses =
      'appointment-type-container d-flex flex-row align-items-center w-100 w-sm-auto position-relative'
    const conditionalClasses = [
      isSelected && 'appointment-type-container-selected',
      isDisabled && 'appointment-type-container-disabled',
      isSelected &&
        isDisabled &&
        'appointment-type-container-selected-disabled',
    ]
      .filter(Boolean)
      .join(' ')

    return `${baseClasses} ${conditionalClasses}`
  }

  return (
    <>
      <div
        key={appointmentTypeId}
        className={getAppointmentContainerClasses(isSelected, isDisabled)}
        onClick={isDisabled ? undefined : handleSelect}
      >
        <div className="appointment-option-info-container">
          <div className="appointment-option-icon-container">
            {appointmentText === 'Medical Visit' ? (
              <MedicalIcon />
            ) : (
              <NutritionIcon />
            )}
          </div>
          <div className="appointment-option-row">
            <p className="appointment-option-text">{appointmentText}</p>
            {isDisabled ? (
              <Box
                borderRadius="full"
                marginRight="2px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                marginBottom="0px"
              >
                <InfoOutlineIcon
                  color="#8F94A3"
                  fontFamily="Inter"
                  height={3}
                  width={3}
                />
                <span className="cancellation-policy">
                  You have an upcoming visit.
                </span>
              </Box>
            ) : null}
          </div>
        </div>

        <RadioInput
          className="appointment-option-input"
          controlId={appointmentTypeId}
          checked={isSelected}
          disabled={isDisabled}
        />
      </div>
    </>
  )
}

export default AppointmentOption
